import useCollections from './use-collection';

export { useCollections };

export default useCollections;
